export const exportToCSV = (filename, headers, rows) => {
  const BOM   = '﻿';
  const today = new Date().toISOString().slice(0, 10);
  const content = [
    headers.join(','),
    ...rows.map(row =>
      row.map(val =>
        `"${String(val ?? '').replace(/"/g, '""').replace(/\n/g, ' ')}"`
      ).join(',')
    ),
  ].join('\n');
  const blob = new Blob([BOM + content], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${today}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
